import { HaulierContractAddress } from '../global/interfaces/address';

type ObjectType<T> = { [key in keyof T]: T[keyof T] };
type RenameKeyMapType<T> = { [key in keyof T]?: string };
type TransformValueMapType<T> = { [key in keyof T]?: (value: any) => any };

const getQueryParamName = <T>(key: keyof T, renameMap: RenameKeyMapType<T> = {}): string => {
  return renameMap[key] ?? (key as string);
};
const getQueryParamValue = <T>(
  key: keyof T,
  object: ObjectType<T>,
  transformMap: TransformValueMapType<T> = {},
): any => {
  const transformCallback: TransformValueMapType<T>[keyof T] = transformMap[key];
  return transformCallback ? transformCallback(object[key]) : object[key];
};

const handleArray = (name, array: any[]) => {
  return array.map((item) => `${name}[]=${item}`);
};
export const objectToQueryParams = <T>(
  object?: ObjectType<T>,
  renameKeyMap: RenameKeyMapType<T> = {},
  transformValueMap: TransformValueMapType<T> = {},
): string => {
  if (!object) return '';
  const queryParams: string[] = [];
  Object.keys(object).forEach((key) => {
    if (object[key] === null || object[key] === undefined || object[key] === '') return;
    const name = getQueryParamName<T>(key as keyof T, renameKeyMap);
    const value = getQueryParamValue<T>(key as keyof T, object, transformValueMap);
    if (Array.isArray(value)) queryParams.push(...handleArray(name, value));
    else queryParams.push(`${name}=${value}`);
  });
  return `${queryParams.join('&')}`;
};

export function addressToQueryParams(prefix: string, address: HaulierContractAddress): string[] {
  const params: string[] = [];
  const hasLatitude = address.latitude != null;
  const hasLongitude = address.longitude != null;
  const hasNonDefaultCoordinates = address.latitude !== 0 || address.longitude !== 0;

  if (hasLatitude && hasLongitude && hasNonDefaultCoordinates) {
    params.push(`${prefix}[latitude]=${address.latitude}`);
    params.push(`${prefix}[longitude]=${address.longitude}`);
  }
  if (address.iso3) params.push(`${prefix}[iso3]=${address.iso3}`);
  const regionCode = (address.regionCode ?? '').trim();
  const country = (address.country ?? '').trim();
  const postalCode = (address.postalCode ?? '').trim();
  const derivedRegionCode = country && postalCode.length >= 2
    ? `${country.toUpperCase()}-${postalCode.slice(0, 2)}`
    : undefined;
  const resolvedRegionCode = regionCode || derivedRegionCode;

  if (resolvedRegionCode) params.push(`${prefix}[regionCode]=${encodeURIComponent(resolvedRegionCode)}`);
  return params;
}
